"use client";
import * as React from "react";
import { Box, Typography } from "@mui/material";
import { MarkdownView } from "../Markdown/MarkdownView";

interface Props { result: any }

export function SubagentResultPreview({ result }: Props) {
  const text = typeof result === "string" ? result : result.text;
  // A divider-separated region inside the card — an inset Soft box here
  // nested a second neumorphic shell inside the card's own and read as
  // "box in a box". Subagent answers are model prose → markdown.
  return (
    <Box sx={{ mt: 1.5, pt: 1.5, borderTop: 1, borderColor: "divider" }}>
      {typeof text === "string" ? (
        <MarkdownView source={text} />
      ) : (
        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
          {JSON.stringify(result, null, 2)}
        </Typography>
      )}
    </Box>
  );
}
